import { SuccessLoader as Success } from './Success/Success';
import { RepeatableLoader as Repeatable } from './Repeatable/Repeatable';

export const Loaders = {
  Success,
  Repeatable,
};
